import { getLDClient } from './launchDarklyClient'

const { hostname, port } = window.location

const resolveEnrollmeOrigin = (useHostname = hostname) => {
  let useNewDomain = false
  try {
    const ldClient = getLDClient()
    useNewDomain =
      ldClient?.variation('temp.ui.admin.new-domain', false) ?? false
  } catch (e) {
    console.error('getImpersonateUrl error trying to get LD client')
    console.error(e)
  }

  const [appPath, env, domain] = useHostname.split('.')
  const [dashname] = appPath.split('-')
  const appName =
    dashname && ['dev', 'qa', 'stage'].includes(dashname)
      ? `${dashname}-enrollme`
      : useNewDomain
        ? 'enrollment'
        : 'enrollme'
  const isValidDomain = !domain?.includes('com')
  const isLocal = appPath.includes('localhost')

  const domainEnv = useNewDomain && env === 'hixme' ? 'sureco' : env

  const path = isLocal
    ? `${appPath}:${port}`
    : `${appName}.${domainEnv}.${isValidDomain ? `${domain}.com` : domain}`

  const protocol = isLocal ? 'http' : 'https'
  return `${protocol}://${path}`
}

/** Employee experience origin (EnrollMe), derived from the admin hostname. */
export const getEnrollmeOrigin = (useHostname = hostname) =>
  resolveEnrollmeOrigin(useHostname)

// moved this out of environment.js, or it errors trying to hit LD
export const getImpersonateUrl = (
  EmployeePublicKey,
  adminId,
  useHostname = hostname
) =>
  `${resolveEnrollmeOrigin(useHostname)}/admin/assume/${EmployeePublicKey}/${adminId}`
